function mergedPlanFeatures(user) {
  return {
    ...(user?.unlockedFeatures || {}),
    ...(user?.currentPlan?.features || {}),
  };
}

export function canAccessProfesionalFeatures(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;
  const slug = (user.currentPlan?.slug || '').toLowerCase();
  if (['profesional', 'empresarial', 'enterprise', 'professional', 'business'].includes(slug)) {
    return true;
  }
  const features = mergedPlanFeatures(user);
  return !!(features.reportesAutomatizados || features.advancedAnalytics || features.flujoDeCaja);
}

/** Cobranzas del wedge (Básico): hub, WhatsApp, gestiones, medios de cobro y resumen en Inicio. */
export function canAccessCobranzasEssential(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;
  if (canAccessProfesionalFeatures(user)) return true;
  const slug = (user.currentPlan?.slug || '').toLowerCase();
  if (slug === 'basico') return true;
  const features = mergedPlanFeatures(user);
  return !!(features.cobranzasEssential || features.calendarioFiscal);
}

export function canAccessCalendarioFiscal(user) {
  return canAccessCobranzasEssential(user);
}
